import type Highcharts from "highcharts";
import debounce from "lodash.debounce";

declare module "highcharts" {
  interface ChartEventsOptions {
    mousemove?: (this: Highcharts.Chart, e: Highcharts.PointerEventObject) => void;
  }
}

export default function mousemoveChartEvent(H: typeof Highcharts) {
  H.wrap(
    H.Chart.prototype,
    "init",
    function (
      this: Highcharts.Chart,
      proceed: { apply: (arg0: Highcharts.Chart, arg1: [Highcharts.Options]) => void },
      ...args: [Highcharts.Options]
    ) {
      proceed.apply(this, args);
      const handleMousemove = debounce(
        e => this.pointer && H.fireEvent(this, "mousemove", this.pointer.normalize(e)),
        100,
        {
          trailing: true,
          leading: false,
          maxWait: 200,
        },
      );
      this.container.addEventListener("mousemove", handleMousemove);
    },
  );
}
